import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaFolder } from "react-icons/fa";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { Modal, Button } from "react-bootstrap";

export default function SubFolder() {
  const { folderId } = useParams();
  const navigate = useNavigate();
  const [subFolderContents, setSubFolderContents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [showAddFolderModal, setShowAddFolderModal] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    GetSubFolderContents();
    GetClientIdByFolderId();
    GetUserData();
  }, [folderId]);

  const handleAddFolderClick = () => {
    setShowAddFolderModal(true);
  };

  const handleCloseModal = () => {
    setShowAddFolderModal(false);
    setFolderName("");
  };
  const GetSubFolderContents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        config.APIACTIVATEURL +
          config.GETFOLDERSBYFOLDERID +
          "?folderId=" +
          folderId,
        {
          ...headerconfig,
        }
      );
      if (response.data.statusCode === 200) {
        setSubFolderContents(response.data.data?.data || []);
      } else {
        setError("Error fetching subfolder contents.");
      }
    } catch (error) {
      setError("Error fetching subfolder contents: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const GetClientIdByFolderId = async () => {
    try {
      const response = await axios.get(
        config.APIACTIVATEURL +
          config.GETCLIENTIDBYFOLDERID +
          "?folderId=" +
          folderId,
        {
          ...headerconfig,
        }
      );
      if (response.data.statusCode === 200) {
        setClientId(response.data.data.clientId);
      }
    } catch (error) {
      console.error("Error fetching ClientId:", error);
    }
  };

  const handleCreateFolder = async () => {
    try {
      if (!folderName.trim()) {
        alert("Please enter a folder name");
        return;
      }

      const formData = new FormData();
      formData.append("folderName", folderName);
      formData.append("parentFolderId", folderId);
      formData.append("clientId", clientId);
      formData.append("companyId", userCompanyId);

      const response = await axios.post(
        config.APIACTIVATEURL + config.CREATEFOLDER,
        formData,
        {
          ...headerconfig,
        }
      );

      if (response.data.statusCode === 200) {
        await GetSubFolderContents();
        handleCloseModal();
      } else {
        alert("Error creating folder: " + response.data.message);
      }
    } catch (error) {
      alert("Error creating folder: " + error.message);
    }
  };
  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };
  const handleSubFolderClick = (subFolderId) => {
    navigate("/file/" + subFolderId);
  };
  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Sub Folders</h4>{" "}
                  {/* Removed mb-sm-0 for consistent spacing */}
                  <div className="d-flex gap-2">
                    {" "}
                    {/* Wrapper for buttons with gap */}
                    <button
                      className="btn btn-success"
                      onClick={handleAddFolderClick}
                    >
                      Add Folder
                    </button>
                    <Link to={"/clientfolder"} className="btn btn-secondary">
                      {" "}
                      {/* Gray outline for Back */}
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <Modal show={showAddFolderModal} onHide={handleCloseModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>Create New Folder</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Folder Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter folder name"
                    value={folderName}
                    onChange={(e) => setFolderName(e.target.value)}
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={handleCreateFolder}>
                  Create Folder
                </Button>
                <Button variant="danger" onClick={handleCloseModal}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-header align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">Sub Folders</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {error ? (
                        <p className="text-danger">{error}</p>
                      ) : subFolderContents.length === 0 ? (
                        <p className="text-center">No subfolders available.</p>
                      ) : (
                        <div className="row">
                          {subFolderContents.map((folder) => (
                            <div
                              key={folder.folderId}
                              className="col-lg-3 col-md-4 col-sm-6 mb-4"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleSubFolderClick(folder.folderId)
                              }
                            >
                              <div className="card text-center shadow-sm">
                                <div className="card-body">
                                  <div className="folder-icon mb-3">
                                    <FaFolder size={40} color="#ff8c00" />
                                  </div>
                                  <div className="folder-name">
                                    {folder.folderName}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
